import { useController } from "react-hook-form";

import FormField, { useFormField } from "./FormField/FormField";
import { FormCheckboxProps } from "./Form.types";

import { Checkbox } from "src/designsystem/Checkbox/Checkbox";

export function FormCheckbox(props: FormCheckboxProps) {
  const { formFieldProps, childProps } = useFormField(props);
  const { field } = useController({ name: childProps.name });

  return (
    <FormField {...formFieldProps}>
      <Checkbox {...childProps} {...field} checked={field.value} />
    </FormField>
  );
}
